import BaseModel from "../../../src/models/BaseModel";
import BaseModelMap from "../../../src/models/BaseModelMap";
import TreeViewModel from "../../../src/models/TreeviewModel";
import type { C1_DefinitionItem } from "./C1_DefinitionItem";

/** Presents the root definition map as a read-only navigator folder. */
export class C1_DefinitionsTreeViewModel extends TreeViewModel {
  get typedObj(): BaseModelMap<C1_DefinitionItem> {
    return this.obj as BaseModelMap<C1_DefinitionItem>;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): BaseModel[] {
    return this.typedObj.asArray();
  }
}

/** Presents one expanded definition and its owned children in the navigator. */
export class C1_DefinitionItemTreeViewModel extends TreeViewModel {
  get typedObj(): C1_DefinitionItem {
    return this.obj as C1_DefinitionItem;
  }

  get isFolder(): boolean {
    return this.typedObj.children.size > 0;
  }

  getTagNeeded(): boolean {
    return true;
  }

  getTag(): string {
    return this.typedObj.getTag();
  }

  getDisableEdit(): boolean {
    return true;
  }

  getFullTitle(): string {
    const language = state.c1.language;
    return this.typedObj.description[language] || this.typedObj.id;
  }

  get childCollection(): BaseModel[] {
    return this.typedObj.children.asArray();
  }
}
